/** ================================================================================
      Cambia el color de los elementos del DOM
    ================================================================================ 
**/ 
let estado = 0; // Variable global para recordar el estado
function cambiarContexto() {
  var botoncontraste = document.getElementById("botoncontraste");
  var botonaumentar = document.getElementById("botonaumentar");
  var botondisminuir = document.getElementById("botondisminuir");
  if (estado === 0) {
    estado = 1;
    // Activar contraste
    document.body.classList.add("all");

    document.querySelectorAll("div").forEach((div) => {
      div.style.backgroundColor = "#000"; // Fondo negro
    });
    document.querySelectorAll("button").forEach((btn) => {
      if (
        btn !== botoncontraste &&
        btn !== botonaumentar &&
        btn !== botondisminuir
      ) {
        btn.style.backgroundColor = "#ddfb00"; // Amarillo
      } else {
        botoncontraste.style.backgroundColor = "#3366CC"; // Azul
        botonaumentar.style.backgroundColor = "#3366CC"; // Azul
        botondisminuir.style.backgroundColor = "#3366CC"; // Azul
      }
    });
  } else {
    estado = 0;
    // Desactivar contraste
    document.body.classList.remove("all");
    document.querySelectorAll("div").forEach((div) => {
      div.style.backgroundColor = ""; // Restaurar al color original
    });
    document.querySelectorAll("button").forEach((btn) => {
      btn.style.backgroundColor = ""; // Restaurar el color original
    });
  }
}
/** ================================================================================
      Disminuye el tamaño de fuente de todos los elementos del DOM
    ================================================================================ 
**/ 
let rootFontSize = parseFloat(
  getComputedStyle(document.documentElement).fontSize
);
function disminuirTamanio() {
  // Recorrer elementos del DOM en orden inverso (de hijos a padres)
  const elements = Array.from(document.querySelectorAll("*")).reverse();
  elements.forEach((el) => {
    const style = window.getComputedStyle(el);
    const fontSize = style.fontSize;
    // Obtener el tamaño numérico y la unidad real (si está definida en el estilo inline)
    let currentValue = parseFloat(fontSize);
    let unit = "px"; // Unidad por defecto (asume px si no se detecta otra)
    // Verificar si el elemento tiene un tamaño definido en su atributo style
    if (el.style.fontSize) {
      unit =
        el.style.fontSize.replace(parseFloat(el.style.fontSize), "") || "px";
    } else {
      // Buscar la unidad del padre más cercano con tamaño explícito
      let parent = el.parentElement;
      while (parent) {
        if (parent.style.fontSize) {
          unit =
            parent.style.fontSize.replace(
              parseFloat(parent.style.fontSize),
              ""
            ) || "px";
          break;
        }
        parent = parent.parentElement;
      }
    }
    // Validar tamaño mínimo y aplicar cambios
    if (currentValue > 10) {
      const newSize = currentValue - 1 + unit;
      el.style.fontSize = newSize;
      // console.log("Elemento:", el.tagName, "| Nuevo tamaño:", newSize);
    }
  });
}

/** ================================================================================
      Aumenta el tamaño de fuente de todos los elementos del DOM
    ================================================================================ 
**/ 
function aumentarTamanio() {
  // Recorrer elementos en orden inverso (hijos -> padres)
  const elements = Array.from(document.querySelectorAll("*")).reverse();

  elements.forEach((el) => {
    const style = window.getComputedStyle(el);
    const fontSize = style.fontSize;
    let currentValue = parseFloat(fontSize);
    let unit = "px";

    // Determinar unidad
    if (el.style.fontSize) {
      unit = el.style.fontSize.replace(currentValue, "") || "px";
    } else {
      // Buscar unidad en padres
      let parent = el.parentElement;
      while (parent) {
        if (parent.style.fontSize) {
          unit = parent.style.fontSize.replace(parseFloat(parent.style.fontSize), "" ) || "px";
          break;
        }
        parent = parent.parentElement;
      }
    }
    // Aumentar tamaño y aplicar
    const newSize = currentValue + 1 + unit;
    el.style.fontSize = newSize;
    // console.log("Elemento:", el.tagName, "| Nuevo tamaño:", newSize);
  });
}
